import { call, put, takeLatest } from 'redux-saga/effects';

import { getPersonalStatus } from '../../services/API/';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getPersonalStatus, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* contactInfoSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
